<ion-header class="light-grey-background">
  <ion-toolbar class="no-background">
    <ion-button (click)="closeModal()" slot="end" fill="clear">
      <ion-icon color="tertiary" slot="icon-only" name="close"></ion-icon>
    </ion-button>
  </ion-toolbar>
</ion-header>

<ion-content class="white-background">
  <label class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 CutomeTextArea" >{{label}}</label>
  <div style="padding:10px">
    <textarea placeholder="Enter text here" name="value" [(ngModel)]="value" class="textareadesign diabledarkmode"></textarea>
 </div>   
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
    <button (click)="getValue()" class="btn btn-primary float-right">{{"common_btn_text.save_btn" | translate}}</button>
  </div>
</ion-content>